/**
 * Text utilities shared across packages.
 */

/**
 * Splits a full name into first name and last name.
 * Uses the last word as the last name, and everything before as the first name.
 *
 * @example
 * getFirstNameAndLastName("Frank Sinatra") // { firstName: "Frank", lastName: "Sinatra" }
 * getFirstNameAndLastName("Zachary Knight Galifianakis") // { firstName: "Zachary Knight", lastName: "Galifianakis" }
 * getFirstNameAndLastName("Me") // { firstName: "Me", lastName: "" }
 */
export const getFirstNameAndLastName = (
  fullName: string | null,
): { firstName: string; lastName: string } => {
  if (!fullName) return { firstName: "", lastName: "" }

  const trimmed = fullName.trim()
  const parts = trimmed.split(" ").flatMap((part) => (part ? [part] : []))

  if (parts.length === 0) {
    return { firstName: "", lastName: "" }
  }

  if (parts.length === 1) {
    return { firstName: parts[0], lastName: "" }
  }

  return {
    firstName: parts.slice(0, -1).join(" "),
    lastName: parts[parts.length - 1] || "",
  }
}
